angular.module('mtic.components.dashboards.teacher_general')
.directive('teacherStudentsWorkspace', function (
  $log,
  $q,
  api,
  EventManager,
  TeacherDataService,
  Firebase,
  $timeout,
  TIMING_CONSTANTS,
  language,
  ModuleFilter,
  PlatformService
) {
  return {
    templateUrl: 'template.html',
    scope: {
      selectedClass: '='
    },
    link: function (scope, element) {
      scope.studentModel = {};

      // $timeout(function(){
      //   moment.locale(language.getCurrentSelectedLanguage());
      // }, 800);

      var eventManager = new EventManager('teacherStudentsWorkspace', scope);
      var screen_width = 0;
      var is_mobile = navigator.userAgent.match(/Android/i) || (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream)
      if(is_mobile) {
        screen_width = window.screen.width
      } else {
        screen_width = window.innerWidth;
      }
      if(screen_width < 1200){
        var timer = is_mobile ? 500 : 0;
        $timeout(function(){
          eventManager.broadcast('teacher:toggle:Sidepanel', false);
        }, timer)
      }
      var filteredResources;
      var selectedStudent;
      TeacherDataService.isTeacherWorkspaceView = true;
      scope.$on('$destroy', function() {
        TeacherDataService.isTeacherWorkspaceView = false;
      });
      scope.slugs = {
        addition:["run_like_math_addition_lv_1","run_like_math_addition_lv_2","run_like_math_addition_lv_3","run_like_math_addition_lv_4","run_like_math_addition_lv_5","run_like_math_addition_lv_6","run_like_math_addition_lv_7","run_like_math_addition_lv_8","run_like_math_addition_lv_9","run_like_math_addition_lv_10"],
        subtraction:["run_like_math_subtraction_lv_1","run_like_math_subtraction_lv_2","run_like_math_subtraction_lv_3","run_like_math_subtraction_lv_4","run_like_math_subtraction_lv_5","run_like_math_subtraction_lv_6","run_like_math_subtraction_lv_7","run_like_math_subtraction_lv_8","run_like_math_subtraction_lv_9","run_like_math_subtraction_lv_10"],
        division:["run_like_math_division_lv_1","run_like_math_division_lv_2","run_like_math_division_lv_3","run_like_math_division_lv_4","run_like_math_division_lv_5","run_like_math_division_lv_6","run_like_math_division_lv_7","run_like_math_division_lv_8","run_like_math_division_lv_9","run_like_math_division_lv_10"],
        multiplication:["run_like_math_multiplication_lv_1","run_like_math_multiplication_lv_2","run_like_math_multiplication_lv_3","run_like_math_multiplication_lv_4","run_like_math_multiplication_lv_5","run_like_math_multiplication_lv_6","run_like_math_multiplication_lv_7","run_like_math_multiplication_lv_8","run_like_math_multiplication_lv_9","run_like_math_multiplication_lv_10"]
      }
      scope.Utils = {
        keys:Object.keys
      }
      scope.selected = {};
      scope.selected.resources = {};
      scope.filterElements = {
        limits: {
          firebase: 200,
          angular: 20
        },
        data: {
          users: [],
          resources: [],
        },
        selected: {
          users: [],
          resources: [],
        }
      }
      scope.data = {
        logs: []
      };
      scope.infoMaps = {
        users: {},
        resources: {},
      };
      scope.loadingStatus = {
        done: false,
        failed: false
      }
      scope.modules = {
        list: [],
        current: null,
        currentChild: null
      };
      scope.diagnosticResult = {
        show:false,
        headers:[]
      }
      scope.logs = [];

      scope.showDiagnosticResult = function(){
        scope.diagnosticResult.show = true;
      }

      scope.closeDiagnosticResultModal  = function(){
        scope.diagnosticResult.show = false;
        scope.diagnosticResult.users = [];
        scope.diagnosticResult.headers = [];
      }

      var has_been_inited = false;
      var init = function(class_id) {
        if(has_been_inited){
          return;
        }
        scope.loadingStatus.done = false;
        scope.loadingStatus.error = false;
        $q.all([
          TeacherDataService.getClassStudentMap(class_id, null, true, false).then(function(students){
            scope.filterElements.data.users = _.orderBy(_.toArray(students), [
              function(student) { return student.info.last_name.toLowerCase()},
              function(student) { return student.info.first_name.toLowerCase()}
            ])
            scope.infoMaps.users = students
            if(filters_to_workspace){
              return;
            }
            scope.filterElements.selected.users = scope.filterElements.data.users
          }),
          TeacherDataService.getModuleResourceListFlatMap(class_id).then(function(resources){
            scope.filterElements.data.resources = _.toArray(resources)
            scope.infoMaps.resources = resources
            scope.module_filtered_list = scope.data.logs
          })
        ]).then(function(){
          if(has_been_inited){
            return;
          }
          // scope.loadingStatus.done = true;
          // scope.loadingStatus.error = false;
          scope.setSelectedStudent(scope.studentModel.student);
          loadLogs(class_id);
        }).catch(function(error){
          $log.error(error);
          scope.loadingStatus.done = true;
          scope.loadingStatus.error = true;
          has_been_inited = false;
        });
      }

      var loadLogs = function(class_id, user_id, resource_id) {        
        var log_data = [];
        if(scope.loadingLogs && (selectedStudent || scope.modules.current)){
          return;
        }

        scope.loadingLogs = true;
        scope.data.logs = [];
        //This one uses srsl for the sidepanel
        api.getClassResourceStates(class_id, false, true, true, user_id, resource_id)
        .then( (data) => {
          data = data.sort(function(a,b){
            if(a.User.ClassWorks[0].StudentResourceStateLogs.id < b.User.ClassWorks[0].StudentResourceStateLogs.id){
              return 1
            }else if(a.User.ClassWorks[0].StudentResourceStateLogs.id > b.User.ClassWorks[0].StudentResourceStateLogs.id){
              return -1
            }
            return 0
          })
          data.forEach( (work) => {
            work.User.ClassWorks.forEach( (class_work) => {
              //class_work.StudentResourceStateLogs.forEach((srsl)=>{
                var srsl = class_work.StudentResourceStateLogs
                if(srsl){
                  var score = scope.infoMaps.resources[class_work.Resource.id] && scope.infoMaps.resources[class_work.Resource.id].display.color === "blue" && srsl.completed ? 1 : srsl.score;
                  log_data.push(
                    {
                      timeSpent: srsl.time_spent,
                      timeStarted: srsl.time_stamp,
                      timeEnded: srsl.time_stamp,
                      score: score,
                      resource_id: class_work.Resource.id,
                      completed: srsl.completed,
                      user_id: work.user_id,
                      alternative_start: srsl.created_at,
                      // app_state: class_work.StudentResourceStateLogs,
                      slug: class_work.Resource.slug,
                      resource_type: class_work.Resource.resource_type,
                      name: class_work.Resource.name
                    }
                  )
                }
              //})
            })
          })
          scope.loadingStatus.done = true;
          scope.loadingStatus.error = false;          
          scope.loadingLogs = false;          
          has_been_inited = true;
          scope.module_filtered_list = scope.data.logs = log_data;
          //This one uses srs for the map
          api.getClassResourceStates(class_id, false, true, false, user_id, resource_id)
          .then( (srs_data) => {
            scope.srs_log_data = [];
            srs_data.forEach( (work) => {
              work.User.ClassWorks.forEach( (class_work) => {
                //class_work.StudentResourceStateLogs.forEach((srsl)=>{
                  var srs = class_work.WorkBatch.StudentResourceState
                  if(srs){
                    var score = scope.infoMaps.resources[class_work.WorkBatch.Resource.id] && scope.infoMaps.resources[class_work.WorkBatch.Resource.id].display.color === "blue" && srs.complete ? 1 : srs.score_max;
                    scope.srs_log_data.push(
                      {
                        score: score,
                        resource_id: class_work.WorkBatch.Resource.id,
                        completed: srs.complete,
                        user_id: work.user_id,
                        slug: class_work.WorkBatch.Resource.slug,
                        resource_type: class_work.WorkBatch.Resource.resource_type,
                        name: class_work.WorkBatch.Resource.name
                      }
                    )
                  }                 
                //})
              })
            })
            try{
              computeModuleStats();
            }
            catch(e){
              // no module selected
            }
          })
          .catch(function(error){          
            has_been_inited = false;
            scope.loadingLogs = false;
            $log.error(error);
            scope.loadingStatus.done = true;
            scope.loadingStatus.error = true;
          });
        })
        .catch(function(error){          
          has_been_inited = false;
          scope.loadingLogs = false;
          $log.error(error);
          scope.loadingStatus.done = true;
          scope.loadingStatus.error = true;
        });

      }

      scope.dateSorter = function(card){
        return new Date(card.timeStarted).getTime() * -1;
      }

      scope.getResourceListing = function(log){
        return scope.infoMaps.resources[log.resource_id]
      }

      scope.getParentResource = function(log){
        if(!scope.infoMaps.resources[log.resource_id]){
          return null;
        }
        return scope.infoMaps.resources[scope.infoMaps.resources[log.resource_id].parent_resource_id]
      }

      scope.unlockedModulesList = [];

      scope.$watch('selectedClass', function(classroom){
        if (classroom){
          refresh();
          init(classroom.id);
          TeacherDataService.getClassFullModules(classroom.id).then(function(moduleListFlat){
            scope.modules.list = moduleListFlat;
            //scope.modules.current = scope.modules.list[0];
          })

          TeacherDataService.getStudentWorkForModuleOfTeacher(classroom.id, true).then(function(moduleData){
            scope.moduleMapData = moduleData;
            scope.currentModule = moduleData.resource_slug;
            eventManager.broadcast("teacher:select:dropdown", {"activity_log": "Modules", "user_id": !selectedStudent ? [] : selectedStudent.user_id, "group_id": scope.selectedClass.id, "resource_slug": scope.moduleMapData.resource_slug });
          })

          scope.setSelectedStudent();


        }
      })

      scope.$watch('modules.list', function(){
        scope.unlockedModulesList = [];
         _.forEach(scope.modules.list, function(module){
          if (ModuleFilter.checkAvailable(module)) {
            scope.unlockedModulesList.push(module)
          }
        })

      })

      scope.returnUnlockedModulesList = function() {
        var availableModules = _.map(scope.modules.list, function(module){
          ModuleFilter.checkAvailable(module)
        })

        return availableModules;
      }

      scope.$watch('modules.current.id', function(newval, oldval){
        if(oldval !== newval && !(scope.modules.current && scope.modules.current.slug === 'run_like_math')){
          loadLogs(scope.selectedClass.id, selectedStudent ? selectedStudent.user_id : null, newval)          
        }
      
        if(newval){
          eventManager.broadcast("teacher:select:dropdown", {"activity_log": "Modules", "user_id": !selectedStudent ? [] : selectedStudent.user_id, "group_id": scope.selectedClass.id, "resource_id": newval });
        }
        else if (scope.moduleMapData) {
          eventManager.broadcast("teacher:select:dropdown", {"activity_log": "Modules", "user_id": !selectedStudent ? [] : selectedStudent.user_id, "group_id": scope.selectedClass.id, "resource_slug": scope.moduleMapData.resource_slug });
        }
      })


      scope.module_filtered_list = [];
      scope.srs_log_data = [];
      var computing = false;
      var computeModuleStats = function(){
        if(computing){
          return;
        }
        computing = true;
        var cur_module;
        if (scope.modules && scope.modules.current){
          cur_module = scope.modules.current;
        }
        if (cur_module){
          // if(scope.moduleMapData && scope.moduleMapData.module_id === 11){
          //   var temp = scope.currentModule;
          //   scope.currentModule='';
          //   $timeout(function(){
          //     scope.currentModule = temp;
          //     scope.selected.resources = {};
          //     scope.filterElements.selected.resources = [];
          //     var runLikeMathModuleId = 192;
          //     scope.module_filtered_list = _.filter(scope.data.logs, function(log){
          //       if(cur_module.id ===runLikeMathModuleId){
          //         return (log.resource_id && scope.infoMaps.resources[log.resource_id] && scope.infoMaps.resources[scope.infoMaps.resources[log.resource_id].parent_resource_id].parent_resource_id === cur_module.id)
          //       }
          //       else{
          //         return (log.resource_id && scope.infoMaps.resources[log.resource_id] && scope.infoMaps.resources[log.resource_id].parent_resource_id === cur_module.id)
          //       }
          //     })
          //     scope.srs_log_data = _.filter(scope.srs_log_data, function(log){
          //       if(cur_module.id ===runLikeMathModuleId){
          //         return (log.resource_id && scope.infoMaps.resources[log.resource_id] && scope.infoMaps.resources[scope.infoMaps.resources[log.resource_id].parent_resource_id].parent_resource_id === cur_module.id)
          //       }
          //       else{
          //         return (log.resource_id && scope.infoMaps.resources[log.resource_id] && scope.infoMaps.resources[log.resource_id].parent_resource_id === cur_module.id)
          //       }
          //     })
          //     eventManager.broadcast('module:change:submodule', cur_module.slug);
          //     eventManager.broadcast('submodule:opened', {
          //       slug: cur_module.slug,
          //       name: cur_module.name
          //     });
              
          //     scope.loadingLogs = false;
          //     computing = false;
          //   }, 100)
          // }
          // else{
            scope.selected.resources = {};
            scope.filterElements.selected.resources = [];
            scope.module_filtered_list = _.filter(scope.data.logs, function(log){
              return (log.resource_id && scope.infoMaps.resources[log.resource_id] && scope.infoMaps.resources[log.resource_id].parent_resource_id === cur_module.id)
            })
            scope.srs_log_data = _.filter(scope.srs_log_data, function(log){
              return (log.resource_id && scope.infoMaps.resources[log.resource_id] && scope.infoMaps.resources[log.resource_id].parent_resource_id === cur_module.id)
            })
            eventManager.broadcast('module:change:submodule', cur_module.slug);
            eventManager.broadcast('submodule:opened', {
              slug: cur_module.slug,
              name: cur_module.name
            });
            computing = false;
          // }
          if(selectedStudent){
            compareSrsSrsl();

            eventManager.broadcast("teacherStudentWorkspace:studentFilter:change",{
              list: getFilteredResources(),
              selectedStudent:selectedStudent
            });
          }
        }
        else{
          scope.selected.resources = {};
          scope.filterElements.selected.resources = [];
          scope.module_filtered_list = scope.data.logs
          eventManager.broadcast('submodule:closed', {})
          eventManager.broadcast('module:change:meta', scope.moduleMapData ? scope.moduleMapData.resource_slug : null);
          computing = false;
        }
      }

      eventManager.listen('ready-for-filters', function(){
        if(TeacherDataService.isTeacherWorkspaceView){
          $timeout(function(){
            if(selectedStudent){
              filteredResources = _.filter(scope.module_filtered_list,function(item){
                return item.user_id === selectedStudent.user_id;
              });
            }else{
              filteredResources = [];
            }
            eventManager.broadcast("teacherStudentWorkspace:studentFilter:change",{list:filteredResources,selectedStudent:selectedStudent});
          },300);
        }
      });

      scope.fromNow = function(time){
        return moment(time).fromNow()
      }

      scope.getTranslation = function(slug){
        return language.get(slug);
      }
      scope.getLang = language.get;

      scope.selectResource = function(resource, bubbleModuleItem) {
        $timeout(function(){
          scope.toggleResourceSelection(resource);
          // scope.filterElements.selected.resources.add(angular.extend(resource, {
          //   deselect: bubbleModuleItem.hideAgendaHighlight
          // }));
          bubbleModuleItem.showAgendaHighlight();
        }, TIMING_CONSTANTS.INSTANT)
      }

      function compareSrsSrsl(){
        var srs_score_map = {};var srsl_score_map = {};
        _.each(scope.module_filtered_list, function(val){
          if(val.score){
            srsl_score_map[val.resource_id] = srsl_score_map[val.resource_id] ? Math.max(srsl_score_map[val.resource_id], val.score) : val.score;
          }
        })
        _.each(scope.srs_log_data, function(val){
          if(val.score){
            srs_score_map[val.resource_id] = srs_score_map[val.resource_id] ? Math.max(srs_score_map[val.resource_id], val.score) : val.score;
          }
        })
        scope.mismatch = false;
        _.each(srsl_score_map, function(val, key){
          if((!srs_score_map[key] && srs_score_map[key] !== 0) || srs_score_map[key] !== val){
            scope.mismatch = true;
          }
        })
        _.each(srs_score_map, function(val, key){
          if((!srsl_score_map[key] && srsl_score_map[key] !== 0) || srsl_score_map[key] !== val){
            scope.mismatch = true;
          }
        })
      }

      function refresh(){
        scope.modules.current = null;
        scope.selected = {};
        scope.selected.resources = {};
        scope.selected.students = {};
        scope.filterElements.selected.users = [];
        scope.filterElements.selected.resources = [];
        scope.module_filtered_list = [];
        filters_to_workspace = false;
        has_been_inited = false;
      }

      scope.setSelectedStudent = function(student){
        if(selectedStudent === student || (!selectedStudent && !student)){
          return;
        }      
        // scope.loadingStatus.done = false;
        // scope.loadingStatus.error = false;
        selectedStudent = student;
        var module_data_id = scope.modules.current ? scope.modules.current.id : null;
        if(!module_data_id && scope.moduleMapData){
          module_data_id = scope.moduleMapData.resource_slug;
        }
        
        if(!selectedStudent){
          scope.studentModel.student = null;
          scope.removeStudentFilter();
          loadLogs(scope.selectedClass.id, null, scope.modules.current ? scope.modules.current.id : null);
          eventManager.broadcast("teacherStudentWorkspace:studentFilter:change",{list:[],selectedStudent:selectedStudent});
          return;
        }
        scope.selected.students = {};
        scope.filterElements.selected.users = [];
        scope.selected.students[selectedStudent.user_id] = selectedStudent;
        scope.filterElements.selected.users = _.map(scope.selected.students);

        loadLogs(scope.selectedClass.id, selectedStudent.user_id, scope.modules.current ? scope.modules.current.id : null);
        eventManager.broadcast("teacherStudentWorkspace:studentFilter:change",{
          list: getFilteredResources(),
          selectedStudent:selectedStudent
        });

        if (scope.modules.current) {
          eventManager.broadcast("teacher:select:dropdown", { "activity_log": "Modules", "user_id": !selectedStudent ? [] : selectedStudent.user_id, "group_id": scope.selectedClass.id, "resource_id": module_data_id });
        }
        else if (module_data_id) {
          eventManager.broadcast("teacher:select:dropdown", { "activity_log": "Modules", "user_id": !selectedStudent ? [] : selectedStudent.user_id, "group_id": scope.selectedClass.id, "resource_slug": module_data_id });
        }
        
      }

      var getFilteredResources = function(){
        if(selectedStudent){
          var filteredResources = _.filter(scope.srs_log_data,function(item){
            return item.user_id === selectedStudent.user_id;
          });
          return filteredResources
        }
        return [];
      }

      $log.debug('teacherStudentWorkspace:studentFilter:request RECEIVED');

      eventManager.listen(
        'teacherStudentWorkspace:studentFilter:request',
        _.throttle(
          function(){
            eventManager.broadcast("teacherStudentWorkspace:studentFilter:change",{
              list: getFilteredResources(),
              selectedStudent:selectedStudent
            });
          },
          500,
          {
            leading: true,
            trailing: true
          }
        )
      );

      scope.removeStudentFilter = function(){
        scope.filterElements.selected.users = [];
        scope.filterElements.selected.users = scope.filterElements.data.users

      }

      scope.toggleResourceSelection = function(resource){
        if(scope.selected.resources[resource.id]){
          delete scope.selected.resources[resource.id];
        }else{
          scope.selected.resources[resource.id] = resource;
        }
        scope.filterElements.selected.resources = _.map(scope.selected.resources)
      }

      eventManager.listen('retrigger-workspace-filters', function(e, args){
        if(!args){
          args = scope.modules.current ? scope.modules.current.slug : null;
        }
        scope.modules.current = null;
        $timeout(function(){
          if(args==="run_like_math"){
            scope.moduleMapData.resources.forEach( function(mod){
              if(mod.slug === args){
                scope.modules.current = mod;
              }
            });
          }else{
            scope.modules.list.forEach( function(mod){
              if(mod.slug === args){
                scope.modules.current = mod;
              }
            });
          }
        }, 50)
      });

      eventManager.listen('creating-items-done', function(e){
        eventManager.broadcast("teacherStudentWorkspace:studentFilter:change",{
          list: getFilteredResources(),
          selectedStudent:selectedStudent
        });
        computeModuleStats();
      })


      scope.intercept = {};
      scope.$watch('intercept.slug', function(clicked_slug){
        if (clicked_slug){
          scope.modules.list.forEach( function(mod){
            if(mod.slug === clicked_slug){
                scope.modules.current = mod;
            }
          })
        }
      });
      scope.getValidation = function(scene){
        if(!scene)
        {
          return false;
        }else{
          var validation = true;
          Object.keys(scene).forEach(function(each){
            validation = validation && scene[each].validation;
          });
          return validation;
        }
      }

      scope.getHeaders = function(filteredList){
        var stateData;
        filteredList.forEach(function(each){
          if(each.slug==='mtic_g78_m0_diag'){
            stateData = each.app_state[0].app_state.state_data
          }
        });
        return stateData;
      }

      scope.getDiagnosticsTakenUsers = function(allUsers,moduleFilteredList){
        var filteredUsers = [];
        allUsers.forEach(function(user){
          moduleFilteredList.forEach(function(each){
            if(each.user_id===user.user_id && each.slug.indexOf("mtic_g78_m0_diag")>-1){
              var userWithDiagnostic = angular.copy(user);
              userWithDiagnostic.headers = angular.copy(each.app_state[0].app_state.state_data);
              filteredUsers.push(userWithDiagnostic);
            }
          });
        });

        return filteredUsers;
      }

      eventManager.listen('module:change:run_like_math', function(e, mod) {
        $timeout(function(){
          scope.modules.current = mod;
        },100);
      });

      eventManager.listen('submodule:change:in:run_like_math', function(e, mod) {
        $timeout(function(){
          scope.modules.current = mod;
        },100);
      });

      eventManager.listen("close:current:module",function(e,mod){
        scope.modules.current = null;
      });

      var filters_to_workspace = false;
      $timeout(function(){        
        eventManager.broadcast('request:tab:options');
      }, 100)
      eventManager.listen('response:tab:options', function(e, args){
        if(!args){
          return;
        }
        if(args.module){
          scope.modules.list.forEach( function(mod){
            if(args && mod.slug === args.module.slug){
              scope.modules.current = mod;
            }
          })
        }
        scope.studentModel.student = args.student.user;
        scope.setSelectedStudent(args.student.user);
        filters_to_workspace = true;
      });

      eventManager.listen('module:change:meta', function(e, data) {
        scope.modules.current = null;
      });

      scope.displayModule = function(option){
        return scope.getTranslation(option.slug)
      }

      scope.customDateSorter = function(card){
        var time = new Date(card.timeStarted).getTime()
        return time;
      }

      scope.getNextLog = function(log){
        if(selectedStudent || scope.modules.current){
          return false;
        }
        return log || true;
      }

      /********************************** Mobile View ***********************************/

      /****** Setting Student table height *****/
      scope.mEls = {};
      var unwatch_studentTable = scope.$watch(()=>{
        if(!PlatformService.isPhonePortrait()) {return false}
        scope.mEls.pageHeader = (scope.mEls.pageHeader || document.querySelector('#nav-display-for-certificate'));
        scope.mEls.workspaceHeader = (scope.mEls.workspaceHeader || document.querySelector('.teacher-page.workspace-nav .mobile-header'));
        scope.mEls.studentTable = (scope.mEls.studentTable || document.querySelector('.teacher-page.workspace-nav .student-list'));
        return !!(scope.mEls.pageHeader && scope.mEls.workspaceHeader && scope.mEls.studentTable && scope.loadingStatus.done && !scope.loadingLogs);
      },(rendered)=>{
        if(rendered){
          $timeout(()=>{
            setStudentTableHeight();
          }, 100)
          unwatch_studentTable();
        }
      });
      function setStudentTableHeight(){
        let remHeight = 0;
        [scope.mEls.pageHeader, scope.mEls.workspaceHeader].map((el)=>{remHeight += (el ? el.getBoundingClientRect().height : 0)});
        scope.mEls.studentTable.style.height = (window.innerHeight - remHeight) + 'px';
        mSetDropdownMenuHeight('body', '.students-select-box', 0.7);
      }
      window.removeEventListener('resize', mOnResize_studentTable);
      window.addEventListener('resize', mOnResize_studentTable);
      function mOnResize_studentTable(){ // in case for some reason mobile browser changes visible viewport height (hides address bar etc)
        if(PlatformService.isPhonePortrait()){
          setStudentTableHeight();
        }
      }
      /*** End of Setting Student table height ***/

      /**
       * Calculates height for dropdown menu
       * @param containerSelector Container element to base available height against.
       * @param dropdownSelector Dropdown selector
       * @param pct Percentage of container height to use.
       */
      function mSetDropdownMenuHeight(containerSelector, dropdownSelector, pct){
        var container = document.querySelector(containerSelector);
        var menu = container.querySelector(dropdownSelector + ' .selectBox__options');
        var maxMenuHeight = (container.offsetHeight * pct) + 'px';
        menu.style['max-height'] = maxMenuHeight;
      }

      scope.mTimeFilters = [{
          id: 'all',
          label: 'All time ranges'
        }, {
          id: 'today',
          label: 'Today',
        }, {
          id: '1week',
          label: '1 Week'
        }, {
          id: '2weeks',
          label: '2 Weeks'
        }, {
          id: '1month',
          label: '1 Month'
        }];
      scope.mTimeFiltersById = {};
      scope.mTimeFilters.map(function(filter){
        scope.mTimeFiltersById[filter.id] = filter;
      });
      scope.mSelectedTimeFilter = scope.mTimeFiltersById.all;
      scope.setSelectedTimeFilter = function(timeFilter){
        scope.mSelectedTimeFilter = timeFilter;
      };
      scope.$watch('mSelectedTimeFilter', (val)=>{
        scope.filterElements.selected.wsTime = scope.mSelectedTimeFilter;
      });
      /****************************** End of Mobile View ********************************/

    }
  }
});
